import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import { Modules } from '@/util/modules'
import { RouteConfig } from 'vue-router'
import { conversationRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
import {useStore} from '../../store'
const ConversationsRouter = () =>
  import(/* webpackChunkName: "conversations" */ '@/apps/conversations/components/v2/ConversationsRouter.vue').then(
    m => m.default
  )

const ManualActionsRouter = () => import(/* webpackChunkName: "manual-actions" */ '@/apps/manual-actions/ManualActionsRouter.vue')
// const ManualActionList = () =>
//   import(/* webpackChunkName: "manual-actions" */ '@/pmd/pages/ManualActionList.vue').then(m => m.default)

const TriggerLinks = () => import(/* webpackChunkName: "trigger-links" */ '@/apps/trigger-links/LinksRouter.vue')

const TriggerLinksOld = () => import(/* webpackChunkName: "trigger-links" */ '@/pmd/pages/links/TriggerLinks.vue')

const LinksPage = () => import(/* webpackChunkName: "m-links" */ '@/pmd/pages/marketing/LinksPage.vue')

const Snippets = () => import(/* webpackChunkName: "snippets" */ '@/pmd/pages/snippets/Snippets.vue')

export const conversationRoute: RouteConfig[] = [
  {
    path: 'conversations',
    name: conversationRouteNames.conversationsV2,
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'conversations/:conversation_id?',
        name: conversationRouteNames.conversationsIdV2,
        component: ConversationsRouter,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Conversations] },
      },
      {
        path: 'manual_actions',
        name: conversationRouteNames.manualActions,
        component: ManualActionsRouter,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.ManualActions] },
      },
      {
        path: 'templates',
        name: conversationRouteNames.conversationsTemplate,
        component: Snippets,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'trigger-links',
        name: conversationRouteNames.triggerLinksConversationsV3,
        component: TriggerLinks,
        beforeEnter: requireAuthAndLocation
      },
      {
        path: 'links',
        name: conversationRouteNames.triggerLinksConversationsV2,
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'link',
            name: conversationRouteNames.triggersLinksLinkConversationsV2,
            component: TriggerLinksOld,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'analyze',
            name: conversationRouteNames.triggersLinksAnalyzeConversationsV2,
            component: LinksPage,
            beforeEnter: requireAuthAndLocation,
            meta: {
              translations: [Modules.TriggerLinkAnalyze, Modules.SmartList],
            },
          }
        ]
      }
    ],
  },
]
